import Marionette from "backbone.marionette";
import { Config } from "../application/Config";
import { EventSummaryView } from "./components/EventSummary";
import "./incoming_events.less";

const REFRESH_INTERVAL = 20000;

export default Marionette.CollectionView.extend({
    className: "incoming-events",
    tagName: 'table',
    childView: EventSummaryView,

    childViewOptions() {
        return {
            settings: this.settings
        }
    },

    fetchData: function () {
        var filters = {
            seller: this.filters.seller.get("id")
        };
        if (!Config.display.get("config").events.listings.all) {
            filters.experience = Config.display.get("config").events.listings.selected.join(",");
        }

        this.collection.fetchDaysEvents({
            data: filters
        });
    },

    initialize(options) {
        this.filters = options.filters;
        this.settings = options.settings;

        this.fetchData();
        this.updateInterval = setInterval(() => {
            this.fetchData()
        }, REFRESH_INTERVAL);


    },

    templateContext() {
        return {
            settings: this.settings.toJSON()
        }
    },

    onBeforeDestroy() {
        clearInterval(this.updateInterval);
        this.updateInterval = null;
    },
});



// WEBPACK FOOTER //
// ./src/js/view/incoming_events.js